import React from 'react';
import {
  Select,
  MenuItem,
  makeStyles,
  FormControl,
  InputBase,
} from '@material-ui/core';

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 140,
    borderRadius: 8,
    fontFamily: 'Poppins, sans-serif',
    fontSize: 14,
    color: '#333',
  },
  inputBase: {
    height: 30,
    padding: '2px 10px',
    border: '1px solid #e0e0e0',
    borderRadius: 8,
    backgroundColor: '#fff',
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    '&:focus': {
      borderColor: '#1976d2',
      boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.1)',
    },
  },
  selectRoot: {
    paddingRight: 28,
  },
  menuPaper: {
    marginTop: 6,
    borderRadius: 8,
    backgroundColor: '#fff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  menuItem: {
    padding: '8px 14px',
    fontSize: 14,
    fontFamily: 'Poppins, sans-serif',
    '&:hover': {
      backgroundColor: '#f8f9fa',
      color: '#1976d2',
    },
    '&.Mui-selected': {
      backgroundColor: '#e3f2fd',
      color: '#1976d2',
      fontWeight: 500,
    },
  },
  placeholderText: {
    color: '#333',
  },
}));

const RangeSelect = ({ value, onChange, options }) => {
  const classes = useStyles();

  return (
    <FormControl className={classes.formControl}>
      <Select
        value={value}
        onChange={onChange}
        displayEmpty
        renderValue={selected =>
          selected ? (
            options.find(opt => opt.value === selected)?.label
          ) : (
            <span className={classes.placeholderText}>Select range</span>
          )
        }
        input={
          <InputBase
            classes={{ root: classes.inputBase, input: classes.selectRoot }}
          />
        }
        MenuProps={{
          classes: { paper: classes.menuPaper },
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          getContentAnchorEl: null,
        }}
      >
        {options.map(opt => (
          <MenuItem
            key={opt.value}
            value={opt.value}
            className={classes.menuItem}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default RangeSelect;
